import { AUTHED_INFOR_LOCAL_STORAGE, JWT_TOKEN_LOCAL_STORAGE, REFRESH_TOKEN_LOCAL_STORAGE } from '@const/auth'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { authApi } from '@services/api'
import { success } from '@services/toast-service'
import { DefaultRootState } from 'react-redux'
import { get, set } from '@services/local-storage-service'

export const loginAction = createAsyncThunk(
  'auth/login',
  async (body: TAuthAPI.Body.Login, { rejectWithValue }) => {
    try {
      const response = await authApi.login(body)
      if (response) {
        const { jwtToken, refreshToken, ...anotherInfor } = response.data
        success('ログインできました。')
        set(JWT_TOKEN_LOCAL_STORAGE, jwtToken)
        set(REFRESH_TOKEN_LOCAL_STORAGE, refreshToken)
        set(AUTHED_INFOR_LOCAL_STORAGE, anotherInfor)
      }
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const changePasswordAction = createAsyncThunk(
  'auth/change-password',
  async (body: TAuthAPI.Body.ForgotPassword, { rejectWithValue }) => {
    try {
      const response = await authApi.forgotPassword(body)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const resetPasswordAction = createAsyncThunk(
  'auth/reset-password',
  async (body: TAuthAPI.Body.ResetPassword, { rejectWithValue }) => {
    try {
      const response = await authApi.resetPassword(body)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const loadUserInfo = createAsyncThunk(
  'auth/loadUserInfo',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as DefaultRootState
      let id = state.auth.informationAuthed.id
      if (!id) {
        const info = get(AUTHED_INFOR_LOCAL_STORAGE) as TAuthDetail.State['informationAuthed']
        id = info.id
      }
      const response = await authApi.me(id)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const createAdmin = createAsyncThunk(
  'auth/createAdmin',
  async (data: any) => {
    const response = await authApi.createAdmin(data)
    return response
  }
)
